"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationClaimShiftStatsDto = instanceOfOrientationClaimShiftStatsDto;
exports.OrientationClaimShiftStatsDtoFromJSON = OrientationClaimShiftStatsDtoFromJSON;
exports.OrientationClaimShiftStatsDtoFromJSONTyped = OrientationClaimShiftStatsDtoFromJSONTyped;
exports.OrientationClaimShiftStatsDtoToJSON = OrientationClaimShiftStatsDtoToJSON;
exports.OrientationClaimShiftStatsDtoToJSONTyped = OrientationClaimShiftStatsDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationClaimShiftStatsDto interface.
 */
function instanceOfOrientationClaimShiftStatsDto(value) {
    if (!('totalNurseCost' in value) || value['totalNurseCost'] === undefined)
        return false;
    if (!('totalCost' in value) || value['totalCost'] === undefined)
        return false;
    if (!('totalMinutesWorked' in value) || value['totalMinutesWorked'] === undefined)
        return false;
    if (!('submittedTimeAt' in value) || value['submittedTimeAt'] === undefined)
        return false;
    return true;
}
function OrientationClaimShiftStatsDtoFromJSON(json) {
    return OrientationClaimShiftStatsDtoFromJSONTyped(json, false);
}
function OrientationClaimShiftStatsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'totalNurseCost': json['totalNurseCost'],
        'totalCost': json['totalCost'],
        'isQualifiedForStipend': json['isQualifiedForStipend'] == null ? undefined : json['isQualifiedForStipend'],
        'totalMinutesWorked': json['totalMinutesWorked'],
        'submittedTimeAt': (json['submittedTimeAt'] == null ? null : new Date(json['submittedTimeAt'])),
    };
}
function OrientationClaimShiftStatsDtoToJSON(json) {
    return OrientationClaimShiftStatsDtoToJSONTyped(json, false);
}
function OrientationClaimShiftStatsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'totalNurseCost': value['totalNurseCost'],
        'totalCost': value['totalCost'],
        'isQualifiedForStipend': value['isQualifiedForStipend'],
        'totalMinutesWorked': value['totalMinutesWorked'],
        'submittedTimeAt': (value['submittedTimeAt'] == null ? null : value['submittedTimeAt'].toISOString()),
    };
}
//# sourceMappingURL=OrientationClaimShiftStatsDto.js.map